var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94171 13.7749C2.65376 12.4869 2.00979 11.843 1.77017 11.0075C1.53055 10.1719 1.73533 9.28455 2.1449 7.50977L2.38109 6.48628C2.72566 4.99315 2.89794 4.24658 3.40917 3.73534C3.9204 3.22411 4.66697 3.05183 6.16011 2.70726L7.1836 2.47107C8.95838 2.0615 9.84577 1.85672 10.6813 2.09634C11.5168 2.33596 12.1608 2.97993 13.4487 4.26788L14.9734 5.79257C17.2142 8.0334 18.3346 9.15381 18.3346 10.5461C18.3346 11.9383 17.2142 13.0588 14.9734 15.2996C12.7326 17.5404 11.6122 18.6608 10.2199 18.6608C8.82763 18.6608 7.70722 17.5404 5.4664 15.2996L3.94171 13.7749Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.17343,
    cy: 7.72656,
    r: 1.66667,
    transform: "rotate(-45 7.17343 7.72656)",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.61739 15.7441L15.4332 9.9281",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/DiscountIcon.ba1983c50f2eaa45b0b7312bdfa6b2b7.svg";
export { ForwardRef as ReactComponent };